import React, { useEffect } from 'react';
import SelectField from '../../../components/Forms/Input/SelectField';
import Checkbox from '../../../components/Forms/Input/Checkbox';
import ToggleSwitch from '../../../components/Forms/Input/ToggleSwitch';
import { useSystemOperationMode } from '../../../hooks/settings/useSystemOperationMode';

const SystemOperationModeForm: React.FC = () => {
  const {
    form,
    updateField,
    handlerSaveConfiguration,
    fetchActiveConfiguration,
    isSubmitting,
  } = useSystemOperationMode();

  useEffect(() => {
    fetchActiveConfiguration();
  }, []);

  return (
    <div className="space-y-12 p-4 sm:p-6">
      {/* ================================
          🔹 Sección: Envío DTE
      ================================= */}
      <div className="space-y-4">
        <div>
          <h3 className="text-lg font-semibold text-black dark:text-white">
            Envío DTE al Ministerio de Hacienda
          </h3>
          <p className="text-gray-500 dark:text-gray-400 mt-1 text-sm">
            Habilita esta opción si el sistema debe emitir y enviar Documentos
            Tributarios Electrónicos.
          </p>
        </div>

        <div className="pl-1 pt-2">
          <Checkbox
            id="dteEnabled"
            label="Activar envío de DTE"
            checked={form.dteEnabled}
            onChange={() => updateField('dteEnabled', !form.dteEnabled)}
          />
        </div>
      </div>

      {/* ================================
          🔹 Sección: Habilitar Impresión
      ================================= */}
      <div className="space-y-4">
        <div>
          <h3 className="text-lg font-semibold text-black dark:text-white">
            Permitir Impresión
          </h3>
          <p className="text-gray-500 dark:text-gray-400 mt-1 text-sm">
            Si está desactivado, el sistema no imprimirá tickets, sin importar
            el modo seleccionado.
          </p>
        </div>

        <ToggleSwitch
          label="Impresión habilitada"
          name="printEnabled"
          checked={form.printEnabled}
          onChange={() => updateField('printEnabled', !form.printEnabled)}
          activeColor="success"
          inactiveColor="danger"
        />
      </div>

      {/* ================================
          🔹 Sección: Modo de Impresión
      ================================= */}
      <div className="space-y-4">
        <div>
          <h3 className="text-lg font-semibold text-black dark:text-white">
            Modo de Impresión
          </h3>
          <p className="text-gray-500 dark:text-gray-400 mt-1 text-sm">
            Selecciona cómo se imprimirán los tickets del sistema.
          </p>
        </div>

        <div className="max-w-md">
          <SelectField
            label="Selecciona el modo de impresión"
            name="printMode"
            value={form.printMode}
            onChange={(e) =>
              updateField('printMode', e.target.value as 'LOCAL' | 'CLOUD')
            }
            options={[
              { label: 'Local (QZ Tray)', value: 'LOCAL' },
              { label: 'Cloud (Servidor)', value: 'CLOUD' },
            ]}
            iconKey="printer"
            required
          />
        </div>
      </div>

      {/* ================================
    🔹 Sección: Operación de Venta
================================= */}
      <div className="space-y-4">
        <div>
          <h3 className="text-lg font-semibold text-black dark:text-white">
            Operación de Venta
          </h3>

          <p className="text-gray-500 dark:text-gray-400 mt-1 text-sm">
            Define cómo trabajará el flujo de ventas dentro del sistema.
          </p>
        </div>

        <div className="max-w-md">
          <SelectField
            label="Modo de operación"
            name="saleOperationMode"
            value={form.saleOperationMode}
            onChange={(e) =>
              updateField(
                'saleOperationMode',
                e.target.value as 'DIRECT_SALE' | 'PENDING_CASHIER'
              )
            }
            options={[
              {
                label: 'Venta Directa',
                value: 'DIRECT_SALE',
              },

              {
                label: 'Venta con Caja',
                value: 'PENDING_CASHIER',
              },
            ]}
            iconKey="terminal"
            required
          />
        </div>
      </div>

      {/* ================================
    🔹 Sección: Inventario
================================= */}
      <div className="space-y-4">
        <div>
          <h3 className="text-lg font-semibold text-black dark:text-white">
            Inventario
          </h3>

          <p className="text-gray-500 dark:text-gray-400 mt-1 text-sm">
            Configura el comportamiento del sistema cuando los productos no
            tienen existencias disponibles.
          </p>
        </div>

        <ToggleSwitch
          label="Mostrar productos sin existencia"
          name="showOutOfStockProducts"
          checked={form.showOutOfStockProducts}
          onChange={() =>
            updateField('showOutOfStockProducts', !form.showOutOfStockProducts)
          }
          activeColor="success"
          inactiveColor="danger"
        />

        <ToggleSwitch
          label="Permitir ventas sin existencia"
          name="allowNegativeStockSales"
          checked={form.allowNegativeStockSales}
          onChange={() =>
            updateField(
              'allowNegativeStockSales',
              !form.allowNegativeStockSales
            )
          }
          activeColor="success"
          inactiveColor="danger"
        />
      </div>

      {/* ================================
          🔹 Botón Guardar
      ================================= */}
      <div className="flex justify-end border-t border-stroke pt-4 dark:border-strokedark">
        <button
          type="button"
          onClick={handlerSaveConfiguration}
          disabled={isSubmitting}
          className="rounded bg-primary px-6 py-2.5 font-medium text-white hover:bg-opacity-90 disabled:opacity-70"
        >
          {isSubmitting ? 'Guardando...' : 'Guardar Configuración'}
        </button>
      </div>
    </div>
  );
};

export default SystemOperationModeForm;
